/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseLinkFragment, LinkFragment, FullLinkFragment} from '@amblique/contentful/app/contentful/fragments/link';

/**
 * Get a single Link by ID (base - scalars only)
 */
export const getBaseLinkById = gql`
  ${BaseLinkFragment}

  query GetBaseLinkById($id: String!, $locale: String!, $preview: Boolean) {
    link(id: $id, locale: $locale, preview: $preview) {
      ...BaseLinkFragment
    }
  }
`;

/**
 * Get a single Link by ID (standard - 1 level deep)
 */
export const getLinkById = gql`
  ${LinkFragment}

  query GetLinkById($id: String!, $locale: String!, $preview: Boolean) {
    link(id: $id, locale: $locale, preview: $preview) {
      ...LinkFragment
    }
  }
`;

/**
 * Get a single Link by ID (full - 2 levels deep)
 */
export const getFullLinkById = gql`
  ${FullLinkFragment}

  query GetFullLinkById($id: String!, $locale: String!, $preview: Boolean) {
    link(id: $id, locale: $locale, preview: $preview) {
      ...FullLinkFragment
    }
  }
`;

/**
 * Get all Link entries with pagination (base - scalars only)
 */
export const getBaseLinks = gql`
  ${BaseLinkFragment}

  query GetBaseLinks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [LinkOrder]
    $where: LinkFilter
    $preview: Boolean
  ) {
    linkCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseLinkFragment
      }
    }
  }
`;

/**
 * Get all Link entries with pagination (standard - 1 level deep)
 */
export const getLinks = gql`
  ${LinkFragment}

  query GetLinks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [LinkOrder]
    $where: LinkFilter
    $preview: Boolean
  ) {
    linkCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...LinkFragment
      }
    }
  }
`;

/**
 * Get all Link entries with pagination (full - 2 levels deep)
 */
export const getFullLinks = gql`
  ${FullLinkFragment}

  query GetFullLinks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [LinkOrder]
    $where: LinkFilter
    $preview: Boolean
  ) {
    linkCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullLinkFragment
      }
    }
  }
`;
